import { Component, OnInit } from '@angular/core';
export class TimelineComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {

    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'hd-timeline',
    template: `
        <div class="items">
            <ng-content></ng-content>
        </div>
    `,
    styles: [`
      :host {
        display: block; }
        :host .items {
          position: relative;
          padding: 0;
          margin: 0; }
        :host .items::before {
          background-color: #ebedf2;
          position: absolute;
          display: block;
          content: '';
          width: 1px;
          height: 100%;
          top: 0;
          bottom: 0;
          left: 3px; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TimelineComponent_tsickle_Closure_declarations() {
/** @type {?} */
TimelineComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TimelineComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
